import { KillSwitchBulkRequest } from "../../../../../api/services/narAgentGrid/types";
import { NarAgentGridTableColumnKeys } from "../../../../../enums/tableColumnKeys";
import { NarAgentGridBulkToggleAction } from "./narAgentGridBulkToggleActions";

type NarAgentGridTableRow = Record<string, any>;

const { Select, AgentMode, AutopassReview } = NarAgentGridTableColumnKeys;

/**
 * Returns table rows whose select checkbox is checked.
 */
export const getSelectedNarAgentGridTableRows = (
  tableData: NarAgentGridTableRow[],
): NarAgentGridTableRow[] =>
  tableData.filter((row) => row[Select]?.isChecked === true);

/**
 * Builds the bulk kill-switch request for selected NAR Agent Grid rows.
 *
 * Each selected row is flipped independently based on the bulk action:
 * Agent Mode toggles only `agent_mode`, Autopass toggles only
 * `autopass_review`, and Both toggles both flags.
 */
export const createBulkTogglePayload = (
  action: NarAgentGridBulkToggleAction,
  selectedRows: NarAgentGridTableRow[],
  clientId: string,
  remarks: string,
  userId: string,
): KillSwitchBulkRequest => {
  const flipAgent =
    action === NarAgentGridBulkToggleAction.AgentMode ||
    action === NarAgentGridBulkToggleAction.Both;
  const flipAutopass =
    action === NarAgentGridBulkToggleAction.AutoPassReviewMode ||
    action === NarAgentGridBulkToggleAction.Both;

  return {
    items: selectedRows.map((row) => {
      const agentMode = row[AgentMode]?.defaultChecked ?? false;
      const autopassReview = row[AutopassReview]?.defaultChecked ?? false;

      return {
        grid_identifier: row[Select]?.id ?? row[AgentMode]?.id ?? "",
        client_id: clientId,
        agent_mode: flipAgent ? !agentMode : agentMode,
        autopass_review: flipAutopass ? !autopassReview : autopassReview,
        remarks,
        user_id: userId,
      };
    }),
  };
};
